import SidebarComponent from "./components/sidebar/sidebar.component"
const WithSidebar = ({ user, role, userMeta, children }) => {
  return (
    <div className="cb-page-container">
      <SidebarComponent user={user} role={role} userMeta={userMeta} />
      {children}
    </div>
  )
}

export default WithSidebar
